import { ApisauceInstance } from 'apisauce';

const postPermissionGranted = (api: ApisauceInstance, tenantId: string) => {
  return api.post('/v1/sso/microsoft/configure', {
    tenantId,
  });
};

export default postPermissionGranted;
